/**
 * investigationStatus — shared status→badge-class mapping for the ADR-082
 * Investigations list + detail views. Kept out of the page components (and
 * out of a *.tsx file) so it isn't co-located with a component export —
 * avoids the react-refresh/only-export-components lint warning that a
 * mixed component+helper export from the same page file would trigger.
 */
export function statusBadgeClass(status: string): string {
  const map: Record<string, string> = {
    active:                  'bg-blue-100 text-blue-800',
    'awaiting-approval':     'bg-amber-100 text-amber-800',
    'awaiting-evidence':     'bg-violet-100 text-violet-800',
    resolved:                'bg-green-100 text-green-800',
    'insufficient-evidence': 'bg-gray-100 text-gray-600',
    abandoned:               'bg-gray-100 text-gray-400',
  }
  return map[status] ?? 'bg-gray-100 text-gray-600'
}
